import React from 'react';
import FormInput from './form-input';

class SearchText extends React.Component {

    setValue(val) {
        this.input.setValue(val);
    }

    render () {
        let name = this.props.name || this.props.id || 'searchText';
        let id = this.props.id || name;

        return (
            <FormInput ref={input => this.input = input} name={name} id={id} type="text" className={['component-search-text', 'search-border', this.props.className].join(' ')} />
        )
    }
}

export default SearchText;



// WEBPACK FOOTER //
// ./web-app/components/search-text.jsx